import { Component } from '@angular/core';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

import { getFilterText } from './HighlightCellRenderer.Component';

export interface ILinkCellCfg {
	href?: string;
	uiSref?: string;
	cssClass?: string;
	iconClass?: string;
	uiSrefParams?: any;
	uiOptions?: any;
	target?: string;
	isIconLink?: boolean;
	callbackFn?: (value: any) => void;
}

export interface ILinkCellRendererParams<T> {
	getCellCfg(rowData: T): ILinkCellCfg;
}

interface ILinkCellRendererMergedParams<T> extends ICellRendererParams, ILinkCellRendererParams<T> {}

import highlightStyles from './HighlightCellRenderer.module.less';

@Component({
	selector: 'link-cell-renderer',
	templateUrl: './LinkCellRenderer.Component.html',
	standalone: false
})
export class LinkCellRendererComponent implements ICellRendererAngularComp {
	public cssClass: string;
	public iconClass: string;
	public href: string;
	public target: string;
	public uiSref: string;
	public uiSrefParams: any;
	public uiOptions: any;
	public callbackFn: (value: any) => void;

	public linkText: string;
	public plainText: string;
	public highlightText: string;
	public highlightClass: string = highlightStyles.highlight;

	public agInit(params: ILinkCellRendererMergedParams<any>): void {
		this.updateCell(params);
	}

	public refresh(params: ILinkCellRendererMergedParams<any>): boolean {
		this.updateCell(params);

		return true;
	}

	private updateCell(params: ILinkCellRendererMergedParams<any>): void {
		//sometimes grid data is null while grid is loading.
		const cfg: any = params.getCellCfg(params.data || {});
		const textValue = params.valueFormatted ?? params.value;

		this.cssClass = cfg.cssClass;
		this.iconClass = cfg.iconClass;
		this.href = cfg.href;
		this.target = cfg.target;
		this.uiSref = cfg.uiSref;
		this.uiSrefParams = cfg.uiSrefParams;
		this.uiOptions = cfg.uiOptions;
		this.callbackFn = cfg.callbackFn;
		this.highlightText = getFilterText(params);

		if (cfg.isIconLink || !this.href && !this.uiSref && !this.callbackFn) {
			this.plainText = textValue;
		} else {
			this.linkText = textValue;
		}
	}
}
